import L from 'leaflet';
import locationIconSvg from "../../../../assets/svg/location_pointer_black.svg"
const locationIcon = new L.Icon({
    iconUrl: locationIconSvg,
    iconRetinaUrl: locationIconSvg,
    popupAnchor:  [-0, -0],
    iconSize: [28,40],     
});

export default  locationIcon